import { render } from "./labelled_value.vue?vue&type=template&id=efe2e15c&scoped=true&lang=pug"
import script from "./labelled_value.vue?vue&type=script&lang=js"
export * from "./labelled_value.vue?vue&type=script&lang=js"

import "./labelled_value.vue?vue&type=style&index=0&id=efe2e15c&lang=scss&scoped=true"

import exportComponent from "../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efe2e15c"]])

export default __exports__